import React from 'react';
import AddressForm from './AddressForm'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';


function ShippingAddress(props) {
  const {data, actions, showErrors} = props

  const address = data.useBillingAddress ? data.billingAddress : data.shippingAddress
  const handleSave = data.useBillingAddress ? function(){} : actions.updateShippingAddress

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Shipping Address
      </Typography>

      <Grid container spacing={24}>
        <Grid item xs={12}>
          <FormControlLabel
            label="Use Billing Address"
            control={
              <Checkbox
                color="secondary"
                name="saveAddress"
                checked={!!data.useBillingAddress}
                onChange={actions.toggleShareAddressField}
              />
            }
          />
        </Grid>
      </Grid>

      <AddressForm
        address={address}
        showErrors={showErrors}
        isShipping
        disabled={data.useBillingAddress}
        onSave={handleSave}
      />
    </React.Fragment>
  );
}

export default ShippingAddress;